import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router";

export default function Auth0ProviderWithNavigate(props) {
    const navigate = useNavigate();

    function onRedirectCallback(appState) {
        console.log("onRedirectCallback", appState);
        navigate(appState?.returnTo ?? "/", { replace: true });
    }

    return (
        <Auth0Provider
            authorizationParams={
                {
                    audience: "https://api.bimproject.cloud",
                    redirect_uri: window.location.origin + "/auth/callback",
                }
            }
            clientId={ process.env.AUTH0_CLIENT_ID }
            domain={ process.env.AUTH0_DOMAIN }
            onRedirectCallback={ onRedirectCallback }
            useRefreshTokens
        >
            { props.children }
        </Auth0Provider>
    );
}

export function useIsStaff() {
    const { user } = useAuth0();
    return user?.org_id === process.env.AUTH0_ORG_ID;
}

export function protectedComponent(Component, FallbackComponent) {
    return function ProtectedComponent() {
        return useIsStaff()
            ? <Component />
            : <FallbackComponent />;
    };
}
